import { z } from "zod/v4";

// GET /api/merchants/summary deliberately omits pay-in account details.
// Keep it distinct from MerchantSchema; never seed a detail query with this data.
export const MerchantSummarySchema = z.object({
  merchantId: z.string(),
  companyName: z
    .string()
    .nullable()
    .transform((name) => name?.trim() || "Unnamed merchant"),
  email: z.string().nullable(),
  applications: z.array(
    z.object({
      merchantId: z.string(),
      applicationId: z.string(),
      applicationName: z.string(),
      hasVirtualAccountsEnabled: z.boolean(),
    }),
  ),
});
export type MerchantSummary = z.infer<typeof MerchantSummarySchema>;
